import { Selectors, getAllRoutes, init } from '@makemydeal/dr-activities-open-deal-v2';
import { APP_NAME, OPEN_DEAL_ROOT_ROUTE } from './constants';
import { hostActions } from './hostActions';

export const openDealAllRoutes = getAllRoutes(OPEN_DEAL_ROOT_ROUTE);
export const openDealRoutes = Object.values(openDealAllRoutes);

let openDealSelectors: Selectors;

const additionalSelectors = {};

export const configureOpenDeal = () => {
    const { selectors, middlewareManager } = init(APP_NAME, additionalSelectors, hostActions, OPEN_DEAL_ROOT_ROUTE);
    openDealSelectors = selectors;
    return middlewareManager;
};

export const getOpenDealSelectors = (): Selectors => openDealSelectors;
